module.exports = __webpack_public_path__ + "static/media/reface_right_side_decorator.276fb840.png";